export const OpenGraphImages = {
  home: {
    url: '/og/main.png',
    type: 'image/png',
    width: 1280,
    height: 720,
    description: 'React Native animations by Reactiive',
  },
  demos: {
    url: '/og/demos.png',
    type: 'image/png',
    width: 1280,
    height: 720,
    description: 'Exclusive weekly React Native animations source code.',
  },
  articles: {
    url: '/og/articles.png',
    type: 'image/png',
    width: 1280,
    height: 720,
    description:
      'Interactive articles about React Native animations by Reactiive',
  },
};
